<template>
	<div>
		<div class="container">
			<div class="header bar">
				<span>개인정보 수집, 이용</span>
				<a href="#" @click.prevent="closeWindow">
					<span class="btn-close">
						닫기
					</span>
				</a>
			</div>
			<div class="contents">
				<div class="info-box">
					'파킹클라우드(주)'는 (이하 '회사'는) 고객님의 개인정보를 중요시하며, "정보통신망 이용촉진 및 정보보호", "개인정보보호법"에 관한 법률을
					준수하고 있습니다.<br />회사는 개인정보처리방침을 통하여 고객님께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며,
					개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니 다. 회사는 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별 공지)을
					통하여 공지할 것입니다.
				</div>
				<div class="data-box">
					<dl>
						<dt>■ 개인정보 수집·이용 (필수)</dt>
						<dt>1. 수집하는 개인정보의 항목 및 이용 목적, 보유기간</dt>
						<dd>
							<table class="tbl-list">
								<caption>
									수집하는 개인정보의 항목 및 이용 목적, 보유기간
								</caption>
								<colgroup>
									<col width="32%" />
									<col width="*" />
								</colgroup>
								<tbody>
									<tr>
										<th scope="col">개인정보 수집자</th>
										<td>
											㈜ 파킹클라우드
										</td>
									</tr>
									<tr>
										<th scope="col">수집 항목</th>
										<td>
											이름, 휴대폰번호
										</td>
									</tr>
									<tr>
										<th scope="col">수집 및 이용 목적</th>
										<td>
											- 월 정기 주차 서비스 이용<br />
											- 이용 안내에 대한 해피콜 및 문자 발송
										</td>
									</tr>
									<tr>
										<th scope="col">보유 및 이용 기간</th>
										<td>
											- 5년 보관 후 즉시 파기<br />
											- 단, 관계 법령에 따라 보존할 필요가 있는 경우 해당 법령에서 요구하는 기한까지 보관
										</td>
									</tr>
								</tbody>
							</table>
						</dd>
					</dl>
					<dl>
						<dt>2. 동의를 거부할 권리 및 동의 거부에 따른 불이익</dt>
						<dd>
							고객님께서 개인정보의 수집, 이용과 관련한 위 사항에 대하여 원하지 않는 경우 동의를 거부할 수 있으나, 동의하지 않을 경우 서비스 이용에
							제한됩니다.
						</dd>
					</dl>
				</div>
				<div class="btn-box">
						<button class="btn big black radius" @click.prevent="closeWindow">확인</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'monthly-parking-terms',
	components: {},
	filters: {},
	mixins: [],
	extends: {},
	props: {},
	data() {
		return {};
	},
	computed: {},
	watch: {},
	methods: {
		closeWindow() {
			return this.$router.go(-1);
		}
	},
	beforeCreate() {},
	created() {},
	beforeMount() {},
	mounted() {},
	beforeUpdate() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {}
};
</script>

<style lang="scss" scoped>
.contents {
	font-size: 0.9em;
	font-weight: 500;
}

.info-box {
	line-height: 150%;
}

dl {
	margin-bottom: 1.6em;

	dt {
		margin-bottom: 0.6em;
		font-weight: 500;
		color: #141414;
	}

	dd {
		line-height: 145%;
		color: #595957;
	}
}
</style>
